define('services/queuesService',[
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird',
    'jquery',
    'services/apiCore',
    'services/authService',
    'models/Queue',
    'models/User'
], function (
    ko,
    _,
    Promise,
    $,
    apiCore,
    authService,
    Queue,
    User
) {
    'use strict';

    var BASE_URI = '/routing/queues';
    var BRIEF_URI = '/routing/queues/divisionviews';

    function getGroupsUri(queueId) {
        return BASE_URI + '/' + queueId + '/groups';
    }

    function getUsersUri(queueId) {
        return BASE_URI + '/' + queueId + '/users';
    }

    function getUserUri(queueId, memberId) {
        return getGroupsUri(queueId) + '/' + memberId;
    }

    var queueService = {
        getQueues: function (options, formatOptions) {
            var parameters = _.assign({
                pageNumber: 1,
                pageSize: 25
            }, options);

            if (_.has(parameters, "name")) {
                // Add a wildcard to the results
                parameters.name = "*" + $.trim(parameters.name) + "*";
            }

            var format = _.assign({
                returnModels: true
            }, formatOptions);

            return apiCore.v2.get(BASE_URI, parameters)
                            .then(function (response) {
                                var results = response;

                                if (!format.returnModels) {
                                    return results;
                                } else {
                                    results.entities = _.map(response.entities, function convertToQueueObj(data) {
                                        return new Queue(data);
                                    });

                                    return results;
                                }
                            });
        },

        getQueue: function (queueId, formatOptions) {
            var format = _.assign({
                returnModel: true
            }, formatOptions);
            var id = ko.unwrap(queueId);

            return apiCore.v2.get(BASE_URI + '/' + id)
                            .then(function (response) {
                                return format.returnModel ? new Queue(response) : response;
                            });
        },
        getQueueMembers: function (queueId, options) {
            var id = ko.unwrap(queueId);
            var parameters = _.assign({
                pageNumber: 1,
                pageSize: 20
            }, options);
            // endpoint does not exist in v2
            return apiCore.v1.get(BASE_URI + '/' + id + '/members', parameters)
                            .then(function (response) {
                                var results = response;

                                results.entities = _.map(response.entities, function convertToUserObj (data) {
                                    data.user = new User(data.user);
                                    return data;
                                });

                                return results;
                            });
        },
        getQueuesBrief: function (options) {
            if (!authService.hasAuthorization('perm:routing:queue:search')) {
                return Promise.reject(new Error("Permission routing:queue:search needed"));
            }

            var parameters = _.assign({
                pageNumber: 1,
                pageSize: 25
            }, options);

            return apiCore.v2.get(BRIEF_URI, parameters)
                            .then(function (response) {
                                return response;
                            });
        },
        getUsers: function (queueId, options) {
            options = _.assign({ pageSize: 25, pageNumber: 1, expand: 'routingStatus' }, options);

            if (_.has(options, "name")) {
                // Add a wildcard to the results
                options.name = "*" + $.trim(options.name) + "*";
            }

            return apiCore.v2.get(getUsersUri(queueId), options);
        },
        updateUsers: function (queueId, users) {
            return apiCore.v2.patch(getUsersUri(queueId), users);
        },
        updateUser: function (queueId, user) {
            return apiCore.v2.patch(getUserUri(queueId, user.id), user);
        },
        getMyQueues: function (options) {
            options = _.assign({ pageSize: 25, pageNumber: 1 }, options);
            return apiCore.v2.get(BASE_URI + '/me', options);
        },
        getUserQueues: function(userId, options){
            options = _.assign({ pageSize: 25, pageNumber: 1 }, options);
            return apiCore.v2.get('/users/' + userId + '/queues', options);
        },
        updateUserJoinedQueues: function(userId, queues){
            return apiCore.v2.patch('/users/' + userId + '/queues', queues);
        }
    };

    return queueService;

});

